import { qsa } from "@fluorescent/dom";

import { section } from "@/glow";
import videoPlayerBlock from "@/lib/video-player-block";
import { animateImageWithContent, shouldAnimate } from "@/lib/animation";

const selectors = {
  videoPlayerVideo: "[data-video-player-block-video]",
  videoPlayerBlock: ".video-player-block",
};

section("image-with-content-split", {
  onLoad() {
    if (shouldAnimate(this.container)) {
      this.animateImageWithContentSplit = animateImageWithContent(this.container);
    }

    const videoPlayerVideos = qsa(selectors.videoPlayerVideo, this.container);

    if (videoPlayerVideos.length) {
      this.videoPlayers = videoPlayerVideos.map(block =>
        videoPlayerBlock(block.closest(selectors.videoPlayerBlock))
      );
    }
  },

  onUnload() {
    this.animateImageWithContentSplit?.destroy();
    this.videoPlayers && this.videoPlayers.forEach(button => button.unload());
  },
});
